export default {"src":"/_next/static/media/cricket-pitch-light.efda35dc.svg","height":106,"width":936,"blurWidth":0,"blurHeight":0};